"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
import { ProfileHeader } from "fansunited-sports-ui";
interface HeaderColors {
  gradientFrom: string;
  gradientTo: string;
  textColor: string;
}
interface BrandedHeaderProps {
  title: string;
  subtitle?: string;
  imageUrl?: string;
  /** Custom image element (e.g. TeamLogo) — takes precedence over imageUrl */
  image?: React.ReactNode;
  colors?: HeaderColors;
  backgroundImageUrl?: string;
  /** When provided, the header becomes a link to this URL */
  href?: string;
  /**
   * Element type used to render the title.
   * Pass "h1" on page-level headers (team / player / competition home / predictor)
   * so the page has a real top-level heading. Defaults to "span" elsewhere.
   */
  titleAs?: React.ElementType;
  /**
   * Optional breadcrumb element rendered at the top of the hero, above the title row.
   * Pass an awaited `<Breadcrumbs ... />` from a server component.
   */
  breadcrumbs?: React.ReactNode;
}
export function BrandedHeader(t0) {
  const $ = _c(24);
  const {
    title,
    subtitle,
    imageUrl,
    image,
    colors,
    backgroundImageUrl,
    href,
    titleAs,
    breadcrumbs
  } = t0;
  const gradientFrom = colors?.gradientFrom || "var(--header-gradient-from, #1f2937)";
  const gradientTo = colors?.gradientTo || "var(--header-gradient-to, #374151)";
  const textColor = colors?.textColor || "var(--header-text, #ffffff)";
  const bgImageUrl = backgroundImageUrl;
  const backgroundStyle = bgImageUrl ? `url(${bgImageUrl}), linear-gradient(to right, ${gradientFrom}, ${gradientTo})` : `linear-gradient(to right, ${gradientFrom}, ${gradientTo})`;
  let t1;
  if ($[0] !== breadcrumbs) {
    t1 = breadcrumbs ? <div className="px-4 pt-4 pb-2 md:pb-4">{breadcrumbs}</div> : null;
    $[0] = breadcrumbs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      imageSize: "3xl",
      typography: {
        name: "text-xl lg:text-3xl font-bold",
        subtitle: "text-sm lg:text-md opacity-70"
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== image || $[4] !== imageUrl || $[5] !== subtitle || $[6] !== title) {
    t3 = {
      image,
      imageUrl,
      name: title,
      subtitle,
      styles: t2
    };
    $[3] = image;
    $[4] = imageUrl;
    $[5] = subtitle;
    $[6] = title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      padding: "6"
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== titleAs) {
    t5 = <ProfileHeader ctaLayout="responsive" titleAs={titleAs} entity={t3} styles={t4} />;
    $[9] = t3;
    $[10] = titleAs;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t5) {
    t6 = <div className="max-w-350 mx-auto py-6">{t1}{t5}</div>;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const content = t6;
  let t7;
  if ($[15] !== backgroundStyle || $[16] !== textColor) {
    t7 = {
      background: backgroundStyle,
      backgroundSize: "cover",
      backgroundPosition: "center",
      color: textColor
    };
    $[15] = backgroundStyle;
    $[16] = textColor;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== content || $[19] !== href) {
    t8 = href ? <Link href={href} prefetch={false} className="block">{content}</Link> : content;
    $[18] = content;
    $[19] = href;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <div style={t7}>{t8}</div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}